<template>
    <div>
         <el-upload 
         class="upload-demo"
         :action="action"
         :on-preview="handlePreview"
         :on-remove="handleRemove"
         :before-remove="beforeRemove"
         :on-success="handleAvatarSuccess"
         :on-exceed="handleExceed"
         multiple
         :limit="1"
         accept=".wgt, .apk"
         :file-list="fileList"
         >
         <el-button size="small" type="primary">上传</el-button>
       </el-upload>
     
    </div>
    
   
   </template>
   <script>
   export default {
     props:{
       // 图片路径
       url:{type:String,default:null},
       // 可接受的格式 'image/png, image/jpeg,image/jpg' file vedio .mp4,/vedio/mp4
       accept: { type: String, default: 'image/png, image/jpeg,image/jpg' },
       // 接受这个参数后 返回可直接赋值给对象  obj={} obj[cateName]=data
       cateName: { type: String, default: '' },
       name: { type: String, default: '' },
       // 图片上传类型  img video
       type: { type: String, default: 'img' },
       // 针对table 编辑用
       index:{ type: [String,Number], default: 0},
       // 展示图片大小
       csssize:{ type: [String,Number], default: '148px'},
       // icon图标大小
       iconsize:{ type: [String,Number], default: '20px'},
       
      
     },
     computed: {
         
       
         cssVars(){
           return {"--csssize": this.csssize,"--iconsize":this.iconsize}
         },
         
       },
       data() {
         return {
           wgtUrl: '',
           showDelete:true,
           dialogVisible:false,
           fileList:[],
           action:localStorage.getItem("upload"),
         };
       },
       watch:{
         url(){
           this.wgtUrl = this.url
           console.log( this.wgtUrl )
           if( this.wgtUrl){
            let fileList=[{name: this.name, url: this.wgtUrl}]
           console.log(fileList)
           this.fileList = fileList
           }else{
            this.fileList = []
           }
         
         }
         },
       methods: {
        handleExceed(files, fileList) {
        this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件，请先删除再上传`);
      },
         handleRemove(file, fileList) {
           console.log(file, fileList);
           this.fileList = []
           this.wgtUrl = ''
           this.$emit('click',  this.wgtUrl , this.cateName,this.index )
         },
         handlePreview(file) {
           console.log(file);
         },
      
         beforeRemove(file, fileList) {
           console.log(file, fileList);
           return this.$confirm(`确定移除 ${ file.name }？`);
         },
   
         handleAvatarSuccess(res, file) {
           console.log(res,file)
           this.wgtUrl = res.data
           console.log(  this.wgtUrl)
             this.$emit('click',  this.wgtUrl , this.cateName,this.index )
         
          
         },
         showcloseDelete(){
      
           this.showDelete = true
         },
         hiddenDelete(){this.showDelete = false},
         delect(){
           this.wgtUrl = ''
         
           this.$emit('click', this.wgtUrl , this.cateName,this.index)
         }
       },
       created() {
         if(this.url){
           this.wgtUrl = this.url
         }
       },
     }
   </script>
   
   <style scoped lang="scss">
     .avatar-uploader{
       display: inline-block !important;
       width: var(--csssize) !important;
       height: var(--csssize) !important;
     }
     .vedio{
       width: var(--csssize) !important;
       height: var(--csssize) !important;
     }
   .avatar-uploader .el-upload {
       border: 1px dashed #d9d9d9;
       border-radius: 6px;
       cursor: pointer;
       position: relative;
       overflow: hidden;
     }
     .avatar-uploader .el-upload:hover {
       border-color: #409EFF;
     }
     .avatar-uploader-icon {
       font-size: 28px;
       text-align: center;
       background-color: #fbfdff;
       border: 1px dashed #c0ccda;
       border-radius: 6px;
       box-sizing: border-box;
       width: var(--csssize);
       height: var(--csssize);
       line-height: var(--csssize);
       vertical-align: top;
     }
     .close-icon{
       position: absolute;
       right: 0;
       top: 0px;
       color: #fff;
       font-size: var(--iconsize);
       z-index: 10;
     }
     .zoom-icon{
       position: absolute;
       left:0px;
       top: 0px;
       color: #fff;
       font-size: var(--iconsize);
       z-index: 10;
     }
     .avatar {
       width: var(--csssize);
       height: var(--csssize);
       display: block;
     }
     .hoverMaster{
       position: relative;
     }
     .hoverMaster::after{
       width: 100%;
       height: 20%;
       background: rgba(0,0,0,0.5);
       
       position: absolute;
       left: 0;
       top: 0;
       z-index: 1;
       content: '';
     }
   </style>